import React, {useEffect, useState, useCallback} from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { useConversation } from '@11labs/react';

import NavBar from './navigation/NavBar';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWifi } from '@fortawesome/free-solid-svg-icons';

import { API_URL } from '../constants/Strings';
import { green } from '../constants/Colors';
import SideBar from './navigation/SideBar';
import PuttrSpinner from './common/PuttrSpinner';
import VoiceActivity from "./coach/VoiceActivity";


function VoiceScreen(props){

  const [debug, setDebug] = useState('DEBUG HOLDER');
  //const [firstName, setFirstName] = useState('there');
  let firstName = 'there';
  let userId = 0;
  let handedness = '';
  let ownsPuttr = '';
  let agentId = 'S3tpW2QgKPrdEMlf1dvv';//default

  const conversation = useConversation({
    onConnect: () => conversationConnect(),
    onDisconnect: () => conversationDisconnect(),
    onMessage: (message) => sendMessage(message),
    onError: (error) => console.error('Error:', error),
  });

  const conversationConnect = () => {
    console.log('Connected');
    sendMessage({source:"CONVERSATION_STATUS", message:conversation.status})
  }
  const conversationDisconnect = () => {
    console.log('Disconnected')
    sendMessage({source:"CONVERSATION_STATUS", message:conversation.status})
  }

  const handleMessage = (msg) => {

    //setDebug("DEBUG:", msg);
    const m = msg.split(".....");

    if (m[1]){

      if (m[0] == "APP"){
        if (m[1] == "START_CHAT"){
          startConversation()
        }
        else if (m[1] == "STOP_CHAT"){
          stopConversation()
        }
      }
      else if (m[0] == "FIRST_NAME"){
        firstName = m[1];
      }
      else if (m[0] == "USER_ID"){
        userId = m[1];
      }
      else if (m[0] == "HANDEDNESS"){
        handedness = m[1];
      }
      else if (m[0] == "OWNS_PUTTR"){
        ownsPuttr = m[1];
      }
      else if (m[0] == "AGENT_ID"){
        agentId = m[1];
      }
    }
  }

  useEffect(() => {

    window.receiveMessage = (message) => {
      handleMessage(message)
    }

    window.addEventListener('message', (nativeEvent) => {

      const s = String(nativeEvent.data);
      handleMessage(s);

    })
    //message to tell app

    setTimeout(() => {sendMessage({source:"APP", message:"LOADED"})}, 500);

  },[]);

  useEffect(() => {
    sendMessage({source:"CONVERSATION_STATUS", message:conversation.status})
    sendMessage({source:"IS_SPEAKING", message:conversation.isSpeaking})
  },[conversation]);

  const sendMessage = (msg) => {
    //break up and compile new string with seperator
    const str = msg.source + "....." + msg.message;

    if (window.ReactNativeWebView){
      window.ReactNativeWebView.postMessage(str);
    }
  }

  const startConversation = useCallback(async () => {
    try {
      // Request microphone permission
      await navigator.mediaDevices.getUserMedia({ audio: true });
      // Start the conversation with your agent
      await conversation.startSession({
        agentId: agentId,
        dynamicVariables: {
          userId: userId,
          firstName: firstName,
          handedness: handedness,
          ownsPuttr: ownsPuttr
        },
      });
    } catch (error) {
      console.error('Failed to start conversation:', error);
    }
  }, [conversation]);
  const stopConversation = useCallback(async () => {
    await conversation.endSession();
  }, [conversation]);
  const renderButton = () => {
    if (conversation.status !== 'connected'){
      return(
        <Button variant="success" onClick={startConversation}>START CHAT</Button>
      );
    }
    else {
      return(
        <Button variant="warning" onClick={stopConversation}>STOP CHAT</Button>
      );
    }
  }
  const renderStatus = () => {
    //disconnected, connecting, connected
    let color = "green"
    if (conversation.status == "disconnected"){
      color = "red";
    }
    else if (conversation.status == "connecting"){
      color = "blue";
    }

    let txt = "LISTENING...";

    if (conversation.isSpeaking){
      txt = "SPEAKING";
    }

    return(
      <div style={{display: 'grid', placeItems: 'center'}}>

        <VoiceActivity isSpeaking={conversation.isSpeaking} />

      </div>
    );
  }
  const renderDebug = () => {
    return(
      <div>{debug}</div>
    );
  }
  return(

    <Container fluid className="align-items-center justify-content-center">

      <div style={{ display: 'flex', height: '100%' }}>

        {renderDebug()}

      </div>

    </Container>

  );
}

const mapStateToProps = state => {
  return {
    app: state.app
  }
};

export default connect(mapStateToProps, null)(VoiceScreen);
